import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "10",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#9AB6DD",
      d: "M13 8.715 7 4.429 1 8.715"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#9AB6DD",
      d: "M13 5.286 7 1 1 5.286"
    }, null, -1)
  ])))
}
export default { render: render }